export default __webpack_public_path__ + "static/media/home-value.400d2163.png";